import { createContext } from "react";

export const TipDelayContext = createContext<{
  sm: number;
  md: number;
  lg: number;
}>({
  sm: 0,
  md: 500,
  lg: 1000,
});
